<template>
    <div :class="classnamebase" class="icon-text-wrapper back-to-element">
        <p
            @click="backTo()"
            :class="classname"
            class="backto button-body go-back-icon"
        >
            Voltar
        </p>
    </div>
</template>
<script>
export default {
    name: "BackTo",
    props: {
        urlreference: {
            type: String,
            required: false,
        },
        classnamebase: {
            type: String,
            required: false,
        },
        classname: {
            type: String,
            required: false,
        },
        sessionname: {
            type: String,
            required: false,
        }
    },
    data: () => {

        return {

            limitwidth: 1180,
            sessionstoragename: 'mobileconditional',
            screenWidth: 1190

        }

    },
    mounted(){

        //Get Width
        this.screenWidth = window.screen.width;

        //Set Conditional for show Mobile Indicate
        this.sessionstoragename = this.sessionname ? this.sessionname : this.sessionstoragename;

    },
    methods: {
        backTo() {

            //Set Session Storage
            if(this.screenWidth <= this.limitwidth){

                sessionStorage.setItem(this.sessionstoragename, true);

            }
           
            //Check UrlReference
            if (this.urlreference) {
                window.location.replace(this.urlreference);

                return;
            }

            //Send Back When do not exist
            window.history.back();
        },
    },
};
</script>
